import BaseResource from './index'

export default class JobTitleResource extends BaseResource {
    static endpoint = '/oasis/restv3/jobTitles'
    static cacheMaxAge = 1800
}
